import React, { useState } from 'react';
import Button from './Button';
import DocumentPreview from './DocumentPreview';
import { FileText } from 'lucide-react';

const DocumentViewer = ({ fileUrl, buttonText = 'View Document' }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePreview = (e) => {
    e.stopPropagation();
    if (fileUrl) {
      setIsPreviewOpen(true);
    }
  };

  if (!fileUrl) {
    return <span>No document available.</span>;
  }

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={handlePreview}
        className="flex items-center space-x-1.5"
      >
        <FileText className="h-4 w-4" />
        <span>{buttonText}</span>
      </Button>

      <DocumentPreview
        isOpen={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        fileUrl={fileUrl}
      />
    </>
  );
};

export default DocumentViewer;
